import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { useAuth } from "../context/AuthContext";
import useApi from "../customHooks/useAPI";

export default function MyOPDs() {
    const { doctorId, hospitalID } = useAuth();
    const { callApi } = useApi();
    const navigate = useNavigate();

    const today = new Date().toISOString().slice(0, 10);

    const [date, setDate] = useState(today);
    const [opds, setOpds] = useState([]);
    const [page, setPage] = useState(0);
    const [size] = useState(10);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        fetchOPDs();
    }, [page, date]);

    const fetchOPDs = async () => {
        setLoading(true);

        console.log(`${process.env.REACT_APP_BACKEND_ENDPOINT}/common/listOPDs?hospital_id=${hospitalID}&doctor_id=${doctorId}&date=${date}&page=${page}&size=${size}`);
        
        try {
            const res = await callApi({
                url: `${process.env.REACT_APP_BACKEND_ENDPOINT}/common/listOPDs?hospital_id=${hospitalID}&doctor_id=${doctorId}&date=${date}&page=${page}&size=${size}`,
                method: "GET",
                headers: {
                    "Admin-Id": "1"
                }
            });
            console.log("OPD Data: ", res);
            
            setOpds(res.data || []);
        } catch (err) {
            console.error("Failed to fetch OPDs", err);
        } finally {
            setLoading(false);
        }
    };

    const handleRowClick = (patientId) => {
        navigate(`/patient/${patientId}`);
    };

    return (
        <div className="bg-white rounded-xl shadow p-5">

            {/* Header */}
            <div className="flex justify-between items-center mb-4">
                <h2 className="text-lg font-semibold">My OPDs</h2>

                {/* Date Control */}
                <input
                    type="date"
                    value={date}
                    onChange={(e) => {
                        setPage(0);
                        setDate(e.target.value);
                    }}
                    className="border rounded-lg px-3 py-2 text-sm"
                />
            </div>

            {/* Table */}
            <div className="overflow-x-auto">
                <table className="min-w-full border border-gray-200 rounded-lg">
                    <thead className="bg-gray-50 text-sm">
                        <tr>
                            <th className="px-4 py-3 text-left">UHID</th>
                            <th className="px-4 py-3 text-left">Patient</th>
                            <th className="px-4 py-3 text-left">Type</th>
                            <th className="px-4 py-3 text-left">Complaint</th>
                            <th className="px-4 py-3 text-left">Status</th>
                        </tr>
                    </thead>

                    <tbody className="text-sm">
                        {loading ? (
                            <tr>
                                <td colSpan={5} className="px-4 py-6 text-center">
                                    Loading...
                                </td>
                            </tr>
                        ) : opds.length === 0 ? (
                            <tr>
                                <td colSpan={5} className="px-4 py-6 text-center text-gray-500">
                                    No OPDs found
                                </td>
                            </tr>
                        ) : (
                            opds.map((opd) => (
                                <tr
                                    key={opd.id}
                                    onClick={() => handleRowClick(opd.opdVisit.patientId)}
                                    className="border-t hover:bg-blue-50 cursor-pointer"
                                >
                                    <td className="px-4 py-3">{opd.opdVisit.uhid || "-"}</td>
                                    <td className="px-4 py-3">{opd.patient_name} (ID: {opd.opdVisit.patientId})</td>
                                    <td className="px-4 py-3">{opd.opdVisit.visitType}</td>
                                    <td className="px-4 py-3 truncate max-w-xs">
                                        {opd.opdVisit.chiefComplaint}
                                    </td>
                                    <td className="px-4 py-3">
                                        <span className="px-2 py-1 text-xs rounded bg-green-100 text-green-700">
                                            {opd.opdVisit.status}
                                        </span>
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>

            {/* Pagination */}
            <div className="flex justify-between items-center mt-4 text-sm">
                <button
                    disabled={page === 0}
                    onClick={() => setPage((p) => p - 1)}
                    className="px-3 py-1 border rounded disabled:opacity-50"
                >
                    Previous
                </button>

                <span>Page {page + 1}</span>

                <button
                    onClick={() => setPage((p) => p + 1)}
                    className="px-3 py-1 border rounded"
                >
                    Next
                </button>
            </div>
        </div>
    );
}
